module.exports = __webpack_public_path__ + "static/img/user.dfdf743c.png";